import { render, staticRenderFns } from "./page-index-categories-content.vue?vue&type=template&id=da12c512&"
import script from "./page-index-categories-content.vue?vue&type=script&lang=ts&"
export * from "./page-index-categories-content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports